// Auth helpers for Emergent-managed Google OAuth.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export function googleLoginRedirect(target = "/dashboard") {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Strip the www. prefix so the OAuth provider's "Sign back in to ..."
  // screen shows the canonical domain ("cartiq360.in") instead of "Www".
  // Same-origin requests are unaffected — both forms route to the same app.
  let origin = window.location.origin;
  try {
    const u = new URL(origin);
    if (u.hostname.startsWith("www.")) {
      u.hostname = u.hostname.replace(/^www\./, "");
      origin = u.origin;
    }
  } catch {
    /* fall through with original origin */
  }
  const redirectUrl = origin + target;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export async function exchangeSessionId(sessionId) {
  const res = await fetch(`${API}/auth/session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ session_id: sessionId }),
  });
  if (!res.ok) throw new Error("session-exchange-failed");
  return res.json();
}

export async function fetchMe() {
  const res = await fetch(`${API}/auth/me`, {
    credentials: "include",
  });
  if (!res.ok) return null;
  return res.json();
}

export async function logout() {
  await fetch(`${API}/auth/logout`, {
    method: "POST",
    credentials: "include",
  });
}
